/*
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-02-18 16:26:50
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-21 08:47:28
 * @FilePath: \zhucai_user\src\store\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    refresh: false,
    Token: null,
    timer: null, // 全局定时器,
    LoginShow: false, // 查看人员ID
    Privacy: "", // 隐私协议
    ServiceAgreement: "", // 服务条款
    siteInfo: {}, //站点信息
    BusinessScope: [], // 业务范围
  },
  mutations: {},
  actions: {},
  modules: {},
});
